<template>
  <div class="report-fs">
    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">تقرير المرتبات - دينار ليبي</h4>
              </div>
            </md-card-header>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>ر.م</md-table-cell>

                    <md-table-cell class="w-200">الاسم</md-table-cell>

                    <md-table-cell class="w-100">المرتب الأساسي</md-table-cell>

                    <md-table-cell class="w-100">المكافآت</md-table-cell>

                    <md-table-cell class="w-100">العلاوات</md-table-cell>

                    <md-table-cell class="w-100">العمل الإضافي</md-table-cell>

                    <md-table-cell class="w-100">إجمالي المرتب</md-table-cell>

                    <md-table-cell class="w-100">الخصومات</md-table-cell>

                    <md-table-cell class="w-100">المرتب الصافي</md-table-cell>
                    <md-table-cell class="w-100">ساعات الحضور</md-table-cell>
                  </md-table-row>
                  <md-table-row
                    v-for="(item, i) in allData.filter((x) => x.currency == 1)"
                    :key="i"
                  >
                    <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                    <md-table-cell class="w-200" md-label="الصنف">{{
                      item.employeeName
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.basicSalary.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalRewards.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalAllowance.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalOverTime.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalSalary.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalDeductions.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.netSalary.toLocaleString()
                    }}</md-table-cell>
                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalWorkHours
                    }}</md-table-cell>
                  </md-table-row>
                  <md-table-row class="footer">
                    <md-table-cell></md-table-cell>

                    <md-table-cell class="w-200 total">المجموع</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("basicSalary", 1)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalRewards", 1)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalAllowance", 1)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalOverTime", 1)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalSalary", 1)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalDeductions", 1)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("netSalary", 1)
                    }}</md-table-cell>
                    <md-table-cell class="w-100">{{
                      sumColumn("totalWorkHours", 1)
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
    <md-card-content v-if="isMultiCurrency" dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <h4 class="title">تقرير المرتبات - دولار</h4>
              </div>
            </md-card-header>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>ر.م</md-table-cell>

                    <md-table-cell class="w-200">الاسم</md-table-cell>

                    <md-table-cell class="w-100">المرتب الأساسي</md-table-cell>

                    <md-table-cell class="w-100">المكافآت</md-table-cell>

                    <md-table-cell class="w-100">العلاوات</md-table-cell>

                    <md-table-cell class="w-100">العمل الإضافي</md-table-cell>

                    <md-table-cell class="w-100">إجمالي المرتب</md-table-cell>

                    <md-table-cell class="w-100">الخصومات</md-table-cell>

                    <md-table-cell class="w-100">المرتب الصافي</md-table-cell>
                    <md-table-cell class="w-100">ساعات الحضور</md-table-cell>
                  </md-table-row>
                  <md-table-row
                    v-for="(item, i) in allData.filter((x) => x.currency == 2)"
                    :key="i"
                  >
                    <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                    <md-table-cell class="w-200" md-label="الصنف">{{
                      item.employeeName
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.basicSalary.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalRewards.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalAllowance.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalOverTime.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalSalary.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalDeductions.toLocaleString()
                    }}</md-table-cell>

                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.netSalary.toLocaleString()
                    }}</md-table-cell>
                    <md-table-cell class="w-100" md-label="الصنف">{{
                      item.totalWorkHours
                    }}</md-table-cell>
                  </md-table-row>
                  <md-table-row class="footer">
                    <md-table-cell></md-table-cell>

                    <md-table-cell class="w-200 total">المجموع</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("basicSalary", 2)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalRewards", 2)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalAllowance", 2)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalOverTime", 2)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalSalary", 2)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("totalDeductions", 2)
                    }}</md-table-cell>

                    <md-table-cell class="w-100">{{
                      sumColumn("netSalary", 2)
                    }}</md-table-cell>
                    <md-table-cell class="w-100">{{
                      sumColumn("totalWorkHours", 2)
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </md-card-content>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["month", "date", "name", "desc", "allData", "pathLogo"],
  mounted() {
    console.warn("allData", this.allData);
  },
  data() {
    return {
      m: env.mTop(),
    };
  },
  methods: {
    sumColumn(columnName, currency) {
      let sum = 0;
      sum = this.allData
        .filter((x) => x.currency == currency)
        .reduce((acc, item) => {
          return acc + item[columnName];
        }, 0);
      return sum.toLocaleString();
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },

    addCommasToNumber(number) {
      let numString = this.round(number, 3).toString();
      numString = numString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return numString;
    },
  },
  computed: {
    isMultiCurrency() {
      return this.$store.state.global.profile.isMultiCurrency;
    },
  },
};
</script>

<style lang="scss" scoped>
.t-body p {
  height: 50px;
}

@import "../../assets/css/report-13";
</style>
